import * as types from "../actions/types";



const initialState = {
    recordId: null,
    records: [],
    transcriptions: [],
    loading: false
};


export default function main (state = initialState, action) {
    switch (action.type) {
      case types.SET_RESUME_RECORD_ID:
        return {
          ...state,
          recordId: action.payload,
        };
      case types.SET_RESUME_RECORDS:
        return {
          ...state,
          records: action.payload,
        };
      case types.SET_RESUME_TRANSCRIPTIONS:
        return {
          ...state,
          transcriptions: action.payload,
        };
      case types.SET_RESUME_LOADING:
        return {
          ...state,
          loading: action.payload,
        };
      default:
        return state;
    }
  }